import { createFileRoute, Link } from "@tanstack/react-router";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";
import { PageHeader } from "@/components/app/shell/page-header";
import { Button } from "@/components/ui/button";
import { useFacility } from "@/lib/facility/facility";
import { ChevronLeft } from "@/lib/icons";
import { guardPermission } from "@/lib/policy/route-guard";
import { ShiftsEditor } from "./-components/shifts-editor";

export const Route = createFileRoute("/_authenticated/_care/care-pass/shifts")({
  beforeLoad: ({ context }) => guardPermission(context.me, "carepass:manage", "/care-pass"),
  component: CarePassShiftsPage,
});

/** The building's care shifts, edited as a whole and saved once. Removing a shift takes its
 * scheduled slots with it, so that is confirmed first. */
function CarePassShiftsPage() {
  const { facilityId } = useFacility();
  const realFacility = facilityId === "all" ? "" : facilityId;
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-5">
      <PageHeader
        title="Care pass shifts"
        meta="The rounds the care pass is worked in. Supervision is owed on every one; laundry, room cleaning and bathing are scheduled onto them."
        actions={
          <Button variant="outline" asChild>
            <Link to="/care-pass">
              <ChevronLeft className="size-4" />
              Care pass
            </Link>
          </Button>
        }
      />
      {realFacility ? (
        <ShiftsEditor key={realFacility} facilityId={realFacility} />
      ) : (
        <OneBuildingCard prompt="Choose a building to set up its care shifts." />
      )}
    </div>
  );
}
